<template>
  <div>
    <div class="row">
      <div class="row mt-4 form-group">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
          <span id="medical_custom"
                class="d-inline-block flexben-tooltip-icon  text-bold">i</span>
            <b-tooltip :target="'medical_custom'" variant="flexben" placement="topleft">
              <div class="text-left">{{ $t('flexben.benefit.tooltips.custom_medical') }}</div>
            </b-tooltip>
            <label for="threshold" class="form-fields-required text-bold mb-0 ml-2 col-form-label p-0"
                   style="min-width:200px">
              {{ $t('flexben.benefit.fields.activate_custom') }}

            </label>
          </div>
          <b-form-checkbox id="threshold"
                           class="ml-4"
                           v-model="localIsCustom"
                           switch>
          </b-form-checkbox>
        </div>
      </div>
      <div class="col-12 col-md-6" v-if="localIsCustom">
        <div class="col-6 col-md-6 form-group">
          <label for="value" class="col-form-label">
            {{ $t('flexben.benefit.fields.value') }}
          </label>
          <input
              id="value"
              type="number"
              class="form-control"
              :class="{'border-danger': Object.keys(errorsBag).includes('value')}"
              min="0"
              v-model="fields.value"
          >
        </div>

        <div class="col-6 col-md-6 form-group">
          <label for="contract_number" class="col-form-label">
            {{ $t('flexben.benefit.fields.contract_number') }}
          </label>
          <input
              id="contract_number"
              type="text"
              class="form-control"
              :class="{'border-danger': Object.keys(errorsBag).includes('contract_number')}"
              v-model="fields.contract_number"
          >
        </div>
      </div>

      <div class="col-12 col-md-6 form-group" v-else>
        <label for="min_order_value" class="col-form-label">
          {{ $t('flexben.benefit.fields.min_order_value') }}
        </label>
        <input
            id="min_order_value"
            type="number"
            class="form-control"
            :class="{'border-danger': Object.keys(errorsBag).includes('min_order_value')}"
            min="0"
            v-model="fields.min_order_value"
        >
      </div>
      <div class="col-12 text-danger" v-if="!localIsCustom">{{ $t('flexben.benefit.fields.info_contract_number') }}</div>
    </div>
    <div class="row mt-4 form-group">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center">
          <span id="medical_threshold_description"
                class="d-inline-block flexben-tooltip-icon  text-bold">i</span>
          <b-tooltip :target="'medical_threshold_description'" variant="flexben" placement="topleft">
            <div class="text-left">{{$t('flexben.benefit.thresholds.tooltip_medical', {value:'medical_insurance'})}}</div>
          </b-tooltip>
          <label for="threshold" class="form-fields-required text-bold mb-0 ml-2 col-form-label p-0"
          v-html="$t('flexben.benefit.thresholds.' + 'medical_insurance')"
                 style="min-width:200px">
            </label>
        </div>
        <b-form-checkbox id="threshold"
                         class="ml-4"
                       v-model="medicalInsuranceLimit"
                       :disabled=true
                       switch>

        </b-form-checkbox>
      </div>
    </div>
    <div class="row form-group mt-2" v-if="shouldShowRoiToggle">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center">
            <span id="roi_description"
                  class="d-inline-block flexben-tooltip-icon mr-2 text-bold">i</span>
          <b-tooltip :target="'roi_description'" variant="flexben" placement="topleft">
            <div class="text-left">{{ $t('flexben.benefit.fields.include_in_roi_report_hint') }}</div>
          </b-tooltip>
          <label for="include_in_roi_report" class="form-fields-required text-bold mb-0 col-form-label p-0" style="min-width: 200px">
            {{ $t('flexben.benefit.fields.include_in_roi_report') }}
          </label>
        </div>
        <b-form-checkbox id="include_in_roi_report"
                         class="ml-4"
                         v-model="fields.include_in_roi_report"
                         switch>
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import {BFormCheckbox, BTooltip} from "bootstrap-vue";

export default {
  name: "BenefitMedicalInsurance",
  components: {
    'b-tooltip': BTooltip,
    "b-form-checkbox": BFormCheckbox,
  },
  props: {
    is_custom: {
      type: Boolean,
      required: true,
    },
    fields: {
      type: Object,
      default: function () {
        return {
          min_order_value: 100,
          value: null,
          contract_number: null,
        };
      },
      required: true
    },
    errorsBag: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    shouldShowRoiToggle: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      medicalInsuranceLimit: true
    }
  },
  computed: {
    localIsCustom: {
      get() {
        return this.is_custom;
      },
      set(value) {
        this.$emit('update:is_custom', value);
      }
    }
  }
}
</script>
